import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/${number | ':itemId'}/findRelatedOrdersTable${`?query=${string}&startDate=${string}&endDate=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:itemId/findRelatedOrdersTable`;

export const URL = (itemId: number, tableRequestModel: TableQuery, startDate: string, endDate: string): RouteDefinition =>
	`${baseRoute}/${itemId}/findRelatedOrdersTable?query=${encodeURIComponent((JSON.stringify(tableRequestModel)))}&startDate=${startDate}&endDate=${endDate}`;
